var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view-documents") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.45,105.49A42.5,42.5,0,1,1,105,63,42.55,42.55,0,0,1,62.45,105.49Zm0-75A32.5,32.5,0,1,0,95,63,32.53,32.53,0,0,0,62.45,30.49Z",
    transform: "translate(-19.96 -20.49)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.06,
    y: 80.72,
    width: 10.84,
    height: 50.6,
    rx: 5.42,
    transform: "translate(-64.03 85.15) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDocuments);
export default __webpack_public_path__ + "static/media/view-documents.6b16c9c69ab8361c395fb01d317ecf7d.svg";
export { ForwardRef as ReactComponent };